<template>
  <div class="login-pwd-reset">
    <form ref="loginForm" :id="'login-form-' + _uid" method="post">
      <div :class="{ 'modal-body': modalElement }">
        <div class="row">
          <div class="col-12">
            <div class="input-unit" data-validate="mail">
              <label :for="'email' + _uid"
                >{{ $translate("Ceres::Template.loginEmail") }}*</label
              >
              <input
                data-testing="email-login"
                type="email"
                name="email"
                autocomplete="email"
                :placeholder="multiLanguage.LoginEmailPlaceholder"
                :id="'email' + _uid"
                v-model="username"
                data-autofocus
              />
            </div>
            <span class="error-msg">
              {{ $translate("Ceres::Template.loginEnterConfirmEmail") }}
            </span>
          </div>
          <div class="col-12">
            <div
              class="input-unit position-relative"
              :class="{ 'no-bottom': modalElement }"
              data-validate="text"
            >
              <label :for="'password' + _uid"
                >{{ $translate("Ceres::Template.loginPassword") }}*</label
              >
              <input
                data-testing="password-login"
                :type="typePassword ? 'password' : 'text'"
                name="password"
                autocomplete="current-password"
                :placeholder="multiLanguage.LoginPasswordPlaceholder"
                :id="'password' + _uid"
                v-model="password"
              />
              <div
                class="position-absolute password-visible cursor-pointer"
                style="top: 2rem; right: 1rem"
                @click="toggleTypePassword"
              >
                <svg
                  v-if="!typePassword"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
                    stroke="#121926"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
                    stroke="#121926"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  v-if="typePassword"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
                    stroke="#121926"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <span class="error-msg">
              {{ $translate("Ceres::Template.loginEmptyPassword") }}
            </span>
          </div>
        </div>
      </div>
      <div class="text-right mb-3">
        <a
          href="javascript:void(0)"
          rel="nofollow"
          @click="showResetPwdView"
          class="text-appearance"
          >{{ $translate("Ceres::Template.loginForgotPassword") }}?</a
        >
      </div>
      <button
        data-testing="submit-login"
        @click.prevent="validateLogin"
        :disabled="isDisabled"
        class="btn btn-primary btn-appearance btn-medium w-100"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
        <span>
          {{ $translate("Ceres::Template.login") }}
        </span>
      </button>
    </form>
  </div>
</template>

<script>
import ApiService from "../../../services/ApiService";
import NotificationService from "../../../services/NotificationService";
import ModalService from "../../../services/ModalService";
import AutoFocusService from "../../../services/AutoFocusService";
import ValidationService from "../../../services/ValidationService";
import { getContainingComponent } from "../../../helper/utils";

export default {
  props: {
    backlink: {
      type: String,
    },
    modalElement: {
      type: String,
    },
    hasToForward: {
      type: Boolean,
      default: false,
    },
    multiLanguage: Object,
  },

  data() {
    return {
      password: "",
      username: "",
      loginFields: [],
      isDisabled: false,
      typePassword: true,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loginFields = this.$refs.loginForm.querySelectorAll(".input-unit");

      AutoFocusService.triggerAutoFocus();
    });
  },

  watch: {
    password(val, oldVal) {
      this.resetError();
    },

    username(val, oldVal) {
      this.resetError();
    },
  },

  methods: {
    toggleTypePassword() {
      this.typePassword = !this.typePassword;
    },
    /**
     * Open the login modal
     */
    showLogin() {
      ModalService.findModal(document.getElementById(this.modalElement)).show();
    },

    validateLogin() {
      ValidationService.validate($("#login-form-" + this._uid))
        .done(() => {
          this.sendLogin();
        })
        .fail((invalidFields) => {
          ValidationService.markInvalidFields(invalidFields, "error");
        });
    },

    /**
     * Send the login data
     */
    sendLogin() {
      this.isDisabled = true;

      ApiService.post(
        "/rest/io/customer/login",
        { email: this.username, password: this.password },
        { supressNotifications: true }
      )
        .done((response) => {
          ApiService.setToken(response);

          NotificationService.success(
            this.$translate("Ceres::Template.loginSuccessful")
          ).closeAfter(3000);

          if (this.backlink !== null && this.backlink) {
            location.assign(decodeURIComponent(this.backlink));
          } else if (this.hasToForward) {
            location.assign(location.origin);
          } else {
            location.reload();
          }
        })
        .fail((response) => {
          this.isDisabled = false;

          switch (response.error.code) {
            case 401:
              this.loginFields.forEach((element) =>
                element.classList.add("has-login-error")
              );

              let translationKey = "Ceres::Template.loginFailed";

              if (
                response.error.message.length > 0 &&
                response.error.message === "user is blocked"
              ) {
                translationKey = "Ceres::Template.loginBlocked";
              }
              NotificationService.error(
                this.$translate(translationKey)
              ).closeAfter(5000);
              break;
            default:
              return;
          }
        });
    },

    showResetPwdView() {
      this.resetError();

      this.$store.dispatch("loadComponent", "forgot-password-modal");

      Vue.nextTick(() => {
        let modalDOM = document.querySelector("#resetPwd");
        let modalVue = getContainingComponent(modalDOM);

        modalVue.$data.username = this.username;

        let showModal = () => ModalService.findModal(modalDOM).show();

        if (this.modalElement) {
          ModalService.findModal(document.getElementById(this.modalElement))
            .hide()
            .then(showModal);
        } else {
          showModal();
        }
      });
    },

    resetError() {
      this.loginFields.forEach((element) =>
        element.classList.remove("has-login-error")
      );
      ValidationService.unmarkAllFields("#login-form-" + this._uid);
    },
  },
};
</script>
